import axios from 'axios';

export const getProducts = async () => {
    try {
        const response = await axios.get('/api/products');
        return response.data;
    } catch (error) {
        console.error('Error fetching products:', error);
        throw error;
    }
}

export const getFeaturedProducts = async () => {
    try {
        const response = await axios.get('/api/products/featured');
        return response.data;
    } catch (error) {
        console.error('Error fetching featured products:', error);
        throw error;
    }
};

export const getProductBySlug = async (slug) => {
    try {
        const response = await axios.get(`/api/products/${slug}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching product with slug ${slug}:`, error);
        throw error;
    }
}